module.exports = __webpack_public_path__ + "img/40_69_013_470.137fd35b.jpg";